export const toggleExpandable = (button: HTMLElement) => {
    const exp = button.closest('.expandable').querySelector('.expansion')
    const innerTextElement = button.querySelector("[data-element=link_text]") as HTMLElement;
    if(exp.classList.contains('show')){
        exp.classList.remove('show') 
        innerTextElement.innerText = 'Leggi di più';
    }else{
        exp.classList.add('show');
        innerTextElement.innerText = 'Leggi di meno';
    }
}